import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/layout/SiteLayout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import NewsListPage from "../pages/news/page";
import NewsDetailPage from "../pages/news-detail/page";
import WorkDetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:type",
        element: <CategoryPage />,
      },
      {
        path: "news",
        element: <NewsListPage />,
      },
      {
        path: "news/:id",
        element: <NewsDetailPage />,
      },
      {
        path: "detail/:type/:id",
        element: <WorkDetailPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;